import LocalStorageAuthorizer from "source/app/infrastructure/Authorizer/LocalStorageAuthorizer";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import * as toastr from "toastr";
import { State } from "../../../services/UI/State/State";
import { ILoginState } from "./ILoginState";
import Login from "../Login";
import { RegisterPasskeyAsync } from "./PasskeyAsync";

export async function LoginAsync(Login: Login) {
    const username = Login.state.username;
    const password = Login.state.password;

    try {
        const login = State.ReadClass<ILoginState>(ESharedComponent.Login);
        const shouldRememberDevice = login.state.shouldRememberDevice;
        const fingerprint = login.state.fingerprint.providedFingerprint;
        const deviceName = login.state.deviceName;

        if (!login.state.fingerprint.isFingerprinted) {
            var response = await ClientDataProvider.Login(
                username,
                password,
                Login.state.totpToken,
                shouldRememberDevice,
                fingerprint,
                deviceName
            );

            // Check if the response is not OK
            if (!response.ok) {
                const errorText = await response.text(); // Read the response body as text
                console.error(errorText); // Log error details

                const errorMessage = `Server error: ${response.status} ${response.statusText} - ${errorText}`;
                throw new Error(errorMessage);
            }

            // Parse the successful response
            const data = await response.json();
            console.log("Login successful:", data);

            if (
                Login.state.isWebAuthnSupported &&
                window.confirm("Add a passkey for faster Face ID / device login?")
            ) {
                await RegisterPasskeyAsync(Login);
            }
        }

        LocalStorageAuthorizer.SignIn(username);
    } catch (error) {
        toastr.error(error.message, "Login error");
    }
}
